import * as fromUsuarioActions from './usuario-grupo.actions';

export const initialState: any = {
  grupos: [],
};

export function reducer(
  state = initialState,
  action: fromUsuarioActions.UsuarioGrupoActions
): any {
  switch (action.type) {
    case fromUsuarioActions.UsuarioGrupoActionTypes.USUARIO_GRUPO_ALL:
      return state;
    case fromUsuarioActions.UsuarioGrupoActionTypes.USUARIO_GRUPO_NEW:
      return (state = action.payload.grupos);
    default:
      return state;
  }
}
